var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ad-accounts-table',{staticClass:"mt-7",attrs:{"headers":_vm.headers,"ad_accounts":_vm.ad_accounts,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }